import {
  Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import { useDeleteTemplateMutation } from '../../Services/templates';

const DeleteTemplateModal = ({ isOpen, onClose, form }) => {
  const [deleteTemplate, { isLoading }] = useDeleteTemplateMutation();
  const toast = useToast();

  const handleDeleteTemplate = async () => {
    await deleteTemplate(form.id);
    toast({
      title: 'Template deleted',
      status: 'success',
      variant: 'left-accent',
      isClosable: true,
      position: 'top',
      duration: 3000,
    });
    onClose();
  };
  if (!isOpen || !form) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete template</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to delete the template
          {' '}
          <b>
            {form.name}
          </b>
          ? You won&apos;t be able to recover the template
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" colorScheme="blue" mr={3} onClick={handleDeleteTemplate} isLoading={isLoading}>
            Delete
          </Button>
          <Button variant="ghost" isDisabled={isLoading} onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteTemplateModal;
